import { Component, inject, input, output } from '@angular/core';
import { TranslatePipe, TranslationService } from '../../../../core/i18n';
import { DeliveryServiceCard } from './delivery-service-card';
import type { DeliveryDateColumn } from './delivery-service-matrix';
import { formatDeliveryDateLabel } from './format-delivery-date-label';

/**
 * Non-selectable arrival-date column with the service offerings for that day.
 */
@Component({
  selector: 'app-delivery-date-column',
  imports: [TranslatePipe, DeliveryServiceCard],
  templateUrl: './delivery-date-column.html',
  styleUrl: './delivery-date-column.scss',
})
export class DeliveryDateColumnComponent {
  private readonly translation = inject(TranslationService);

  readonly column = input.required<DeliveryDateColumn>();
  readonly selectedProductCode = input<string | null>(null);
  readonly fastestProductCode = input<string | null>(null);
  readonly mostEconomicalProductCode = input<string | null>(null);
  readonly offeringSelect = output<string>();

  /**
   * Formats a YYYY/MM/DD delivery date as an uppercase weekday/month header
   * using the active UI locale (fr-CA / en-CA).
   */
  protected formatArrivingOnDate(deliveryDate: string): string {
    this.translation.revision();
    const locale = this.translation.locale() === 'fr' ? 'fr' : 'en';
    return formatDeliveryDateLabel(deliveryDate, locale).toUpperCase();
  }

  /**
   * Forwards a card selection to the parent matrix.
   */
  protected onSelect(productCode: string): void {
    this.offeringSelect.emit(productCode);
  }
}
